<template>
  <div class="table-responsive">
    <table class="table table-borderless table-sm w-100 table-lista">
      <thead>
        <tr>
          <th scope="col" class="text-left" style="width: 15%;">Atendimento</th>
          <th scope="col" class="text-left" style="width: 15%;">Operadora</th>
          <th scope="col" class="text-left" style="width: 35%;">Serviço</th>
          <th scope="col" class="text-center" style="width: 10%;">Quantidade</th>
          <th scope="col" class="text-center" style="width: 12%;">Valor Unitário</th>
          <th scope="col" class="text-right" style="width: 13%;">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="text-left">{{ item.dtatendimento | formatDate }}</td>
          <td class="text-left">{{ item.operadora || 'UNIMED BH' }}</td>
          <td class="text-left">{{ item.descrservico }}</td>
          <td class="text-center">{{ item.quantidade || 1 }}</td>
          <td class="text-center">{{ item.vlrunitario | currency }}</td>
          <td class="text-right">{{ item.vlrtotal | currency }}</td>
        </tr>
        
        <tr class="linha-total" v-if="items.length > 0">
          <td colspan="3" class="text-right pr-4" style="font-weight: 800;">TOTAL:</td>
          <td class="text-center" style="font-weight: 800; color: #000;">{{ totaisVida.quantidade }}</td>
          <td class="text-center" style="font-weight: 800; color: #000;">-</td>
          <td class="text-right" style="font-weight: 800; color: #000;">{{ totaisVida.valorTotal | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ListaUnimed",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    // Calcula a soma da quantidade e do valor total
    totaisVida() {
      return this.items.reduce((acumulador, item) => {
        acumulador.quantidade += (item.quantidade || 1);
        acumulador.valorTotal += (item.vlrtotal || 0);
        return acumulador;
      }, { quantidade: 0, valorTotal: 0 });
    }
  },
  filters: {
    // Formata o valor para Reais (R$)
    currency(valor) {
      if (valor === undefined || valor === null) return "R$ 0,00";
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
    // Formata a data (ajusta automaticamente se vier com traços)
    formatDate(val) {
      if (!val) return "";
      if (val.includes("-")) {
        const parts = val.split('T')[0].split('-');
        if (parts.length === 3) {
          return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
      }
      return val;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-lista {
  margin-bottom: 0;

  th {
    color: #222;
    font-weight: 400; /* Ajustado para bater com a sua imagem mais recente */
    font-size: 14px;
    border: none;
    padding-bottom: 10px;
  }

  td {
    color: #212529;
    font-weight: 400;
    font-size: 14px;
    border-color: #e9ecef;
    vertical-align: middle;
    padding: 8px 5px;
  }

  /* Estilo garantido para a linha de total */
  .linha-total td {
    border-top: 2px solid #dee2e6 !important; /* Cria a linha divisória acima do total */
    background-color: #f8f9fa; /* Um fundo bem clarinho para destacar */
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
</style>